import { PRODUCT_FOR_ADD_TO_CART } from '@src/components/ProductPage/ProductThumbnail/queries';
import gql from 'graphql-tag';

export const ME_FOR_WISHLIST = gql`
  ${PRODUCT_FOR_ADD_TO_CART}
  query meForWishlist($first: Int, $after: String, $forMgs: Boolean) {
    me {
      id
      wishlist {
        id
        items(first: $first, after: $after, forMgs: $forMgs) {
          totalCount
          pageInfo {
            startCursor
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              product {
                ...productForAddToCart
                brand
                brandLink {
                  id
                }
                images {
                  id
                  url
                }
                thumbnail {
                  url
                  alt
                }
                urlForGraphql
                productReviewsAggregation {
                  id
                  rating
                  reviewCount
                }
                price {
                  amount
                }
                notifyStatus
              }
            }
          }
        }
      }
    }
  }
`;

export const WISHLIST_ADD = gql`
  mutation addWishlist($productId: ID!) {
    wishlistAddProduct(product_id: $productId) {
      errors {
        field
        message
      }
      wishlist {
        id
      }
    }
  }
`;

export const WISHLIST_DELETE = gql`
  mutation deleteWishlist($productId: ID!) {
    wishlistDeleteItemByProduct(product_id: $productId) {
      errors {
        field
        message
      }
      wishlist {
        id
      }
    }
  }
`;
